<ion-content [fullscreen]="true">
  <ion-grid>
    <ion-row>
      <ion-col>
        <app-info-varsling-popup
          *ngFor="let i = index; let message; of: infoMessages"
          [popupId]="i"
          [message]="message"
        ></app-info-varsling-popup>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-title>
          <h1>Nytt og nyttig</h1>
        </ion-title>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="isNarrow" class="buttonrow">
      <ion-button [class.dark]="showTilbud" (click)="setShowTilbud(true)"
        >Tilbud</ion-button
      >
      <ion-button [class.dark]="!showTilbud" (click)="setShowTilbud(false)"
        >Nyheter</ion-button
      >
    </ion-row>
    <ion-row class="nyttig-articles-container-row">
      <ion-col
        *ngIf="showTilbud || !isNarrow"
        size="12"
        size-lg="6"
        class="ion-padding"
      >
        <ion-row class="m-b articleCardN" *ngFor="let article of (tilbud)">
          <ion-col
            class="abstract flex"
            size="12"
            size-sm="8"
            size-md="6"
            size-lg="6"
            size-xl="6"
          >
            <h2>{{article.title}}</h2>
            <p>{{article.lead}}</p>
            <ion-button
              class="dark"
              (click)="navToArticle(article.slug.current)"
            >
              Trykk for å lese
              <span
                class="fas fa-long-arrow-alt-right"
                style="padding-left: 5px"
              ></span>
            </ion-button>
          </ion-col>
          <ion-col
            size="12"
            size-sm="4"
            size-md="6"
            size-lg="6"
            size-xl="6"
            class="image"
            [style.background-image]="getBackground(article.image.src)"
          >
          </ion-col>
        </ion-row>
      </ion-col>

      <ion-col
        *ngIf="!showTilbud || !isNarrow"
        size="12"
        size-lg="6"
        class="ion-padding"
      >
        <ion-row *ngFor="let article of (nyheter)" class="m-b articleCardN">
          <ion-col
            class="abstract flex"
            size="12"
            size-sm="8"
            size-md="6"
            size-lg="6"
            size-xl="6"
          >
            <h2>{{article.title}}</h2>
            <p>{{article.lead}}</p>
            <ion-button
              class="dark"
              (click)="navToArticle(article.slug.current)"
            >
              Trykk for å lese
              <span
                class="fas fa-long-arrow-alt-right"
                style="padding-left: 5px"
              ></span>
            </ion-button>
          </ion-col>
          <ion-col
            class="image"
            size="12"
            size-sm="4"
            size-md="6"
            size-lg="6"
            size-xl="6"
            [style.background-image]="getBackground(article.image.src)"
          >
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="tab-content-bottom-margin"></div>
</ion-content>
